import { useState } from "react"

export const useCarouselWithIndicator = (lengthAssets: number) => {
  const [currentIndex, setCurrentIndex] = useState<number>(0)
  const firstImageIndex = 0
  const lastImageIndex = lengthAssets - 1

  const onHandleNext = () => {
    setCurrentIndex(index => {
      if (index === lastImageIndex) {
        return 0
      }
      return index + 1
    })
  }

  const onSelectImage = (index: number) => {
    setCurrentIndex(index)
  }

  const setPaginate = (newDirection: number) => {
    setCurrentIndex(prevIndex => {
      let newIndex = prevIndex + newDirection

      if (newIndex < 0) {
        return lastImageIndex
      } else if (newIndex >= lengthAssets) {
        return firstImageIndex
      }
      return newIndex
    })
  }

  return {
    firstImageIndex,
    currentIndex,
    onHandleNext,
    onSelectImage,
    setPaginate,
  }
}
